import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource/archivo-black/400.css";
import "@fontsource/bungee/400.css";
import "@fontsource/space-mono/400.css";
import "@fontsource/space-mono/700.css";
import "./styles.css";
import { App } from "./App";
import { ServicesContext, type Services } from "./components/Services";
import { ThemeContext } from "./components/ThemeContext";
import { ApiClient } from "./lib/api";
import { detectTheme } from "./lib/theme";
import { CloudflareTurnstile, siteKeyFromEnv } from "./lib/turnstile";

const base = (import.meta.env.VITE_API_BASE as string | undefined) ?? "";
const theme = detectTheme(window.location);
const api = new ApiClient({ base });
const services: Services = {
  api,
  turnstile: new CloudflareTurnstile(siteKeyFromEnv(import.meta.env.VITE_TURNSTILE_SITE_KEY as string | undefined), "dark"),
  streamUrl: (path) => api.url(path),
};

const root = document.getElementById("root");
if (!root) throw new Error("#root missing");
createRoot(root).render(
  <StrictMode>
    <ThemeContext.Provider value={theme}>
      <ServicesContext.Provider value={services}>
        <App />
      </ServicesContext.Provider>
    </ThemeContext.Provider>
  </StrictMode>,
);
